import { render, staticRenderFns } from "./customerGroup.vue?vue&type=template&id=f6007dd0&scoped=true&"
import script from "./customerGroup.vue?vue&type=script&lang=js&"
export * from "./customerGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6007dd0",
  null
  
)

export default component.exports